import { ISelectItem } from '@lla-platform/core/core-ui'

export enum AnchorType {
  OilChangeBlend = 'OilChangeBlend',
  OilChangeSynthetic = 'OilChangeSynthetic',
  OilChangeDiesel = 'OilChangeDiesel',
  OilChangeFree = 'OilChangeFree'
}

export const AnchorTypeToLabel: { [key: string]: string } = {
  OilChangeBlend: 'Oil Change Blend',
  OilChangeSynthetic: 'Oil Change Synthetic',
  OilChangeDiesel: 'Oil Change Diesel',
  OilChangeFree: 'Oil Change Free'
}

export const AnchorTypeItems: ISelectItem[] = [
  {
    label: AnchorTypeToLabel[AnchorType.OilChangeBlend],
    value: AnchorType.OilChangeBlend
  },
  {
    label: AnchorTypeToLabel[AnchorType.OilChangeSynthetic],
    value: AnchorType.OilChangeSynthetic
  },
  {
    label: AnchorTypeToLabel[AnchorType.OilChangeDiesel],
    value: AnchorType.OilChangeDiesel
  },
  {
    label: AnchorTypeToLabel[AnchorType.OilChangeFree],
    value: AnchorType.OilChangeFree
  }
]
